import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueRx from 'vue-rx'
import VueStripeCheckout from 'vue-stripe-checkout'
import browserUpdate from 'browser-update'
browserUpdate({
  required: {
    e: -2,
    i: 11,
    f: -3,
    o: -3,
    s: 10.1,
    c: '64.0.3282.16817',
    samsung: 7.0,
    vivaldi: 1.2
  },
  insecure: true
})

Vue.use(VueStripeCheckout, 'pk_live_EWOEwrX2195dq1b2OJa7nzoi')
Vue.use(VueRx)

Vue.config.productionTip = true
Vue.config.performance = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
